export const validateShankSideDiamondFields = (filters) => {
  const fieldNames = [
    'distance_diamonds_down_sides_of_shank',
    'quality_of_diamonds_down_sides_of_shank',
    'setting_style_of_diamonds_down_sides_of_shank',
    'milgrain_sides_of_shank'
  ]

  const fieldErrorMsgMapping = {
    'distance_diamonds_down_sides_of_shank': 'Distance of Diamonds on Outside Sides of Shank',
    'quality_of_diamonds_down_sides_of_shank': 'Quality of Diamonds on Outside Sides of Shank',
    'setting_style_of_diamonds_down_sides_of_shank': 'Setting Style of Diamonds on Outside Sides of Shank',
    'milgrain_sides_of_shank': 'Milgrain on Outside Sides of Shank'
  }
  let missingFields = fieldNames.filter((e) => { return filters[e] === null })
  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/shank-side-diamond-fields/index.js